import * as React from 'react'

import { KEY_POSITIONS } from './constants'
import { showKeyIndicator } from './helpers'
import Sketch from './Sketch'

const getSketch = (width: number, height: number) => (p: any) => {
  let previousPosition: { x: number, y: number }

  p.setup = () => {
    p.createCanvas(width, height)
    p.stroke('white')
  }

  p.draw = () => {
    p.background(0, 4)
  }

  p.keyTyped = () => {
    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      const x = position.x * width
      const y = position.y * height

      if (previousPosition) {
        p.line(previousPosition.x, previousPosition.y, x, y)
      }

      previousPosition = { x, y }

      showKeyIndicator(p)
    }
  }
}

const prompt = 'Draw with your keyboard'

const Draw = () => <Sketch getSketch={getSketch} prompt={prompt} />

export default Draw



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Lines.tsx